import classNames from 'classnames';
import React from 'react';
import { ErrorCircleIcon } from '../../Components/Icons';
import { ValidationFailure } from '../../Shared/DomainValidationFunctions';
import { red, white } from '../../Styles/Colours';
import styles from './MedicationListErrors.module.scss';

export const MedicationListErrors = (props: { errors: ValidationFailure[] }) => {
    const errors = props.errors;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>Error</div>
            </div>
            <div className={styles.body}>
                {errors.map((it, index) => (
                    <div key={`${it.errorCode}-${index}`} className={classNames(styles.row, styles.errorRow)}>
                        <GeneralError message={it.errorMessage} />
                    </div>
                ))}
            </div>
        </div>
    );
};

const GeneralError: React.FC<{
    message: string;
}> = props => {
    return (
        <div className={styles.generalError}>
            <div className={styles.informationHeader}>
                <div className={styles.icon}>
                    <ErrorCircleIcon backgroundColour={red} color={white} size='40' />
                </div>
                <div className={styles.name}>{props.message}</div>
            </div>
        </div>
    );
};
